import {NgModule} from '@angular/core';
import {TableColumnsResizerDisabledDirective} from './table-columns-resizer-disabled.directive';
import {TableColumnsResizerComponent} from './table-columns-resizer.component';

@NgModule({
    declarations: [
        TableColumnsResizerComponent,
        TableColumnsResizerDisabledDirective
    ],
    exports: [
        TableColumnsResizerDisabledDirective
    ]
})
export class TableColumnsResizerModule {}
